import {
  TouchlessSetupOrder,
  MeetingsSetupOrder,
  CalendarSeatSetupOrder,
} from 'constants/flowConstants'

const getRoot = state => state.routing
export const getPathname = state => getRoot(state).location.pathname
export const getSearch = state => getRoot(state).location.search

const getOrder = (pathname, state) => {
  if (pathname.startsWith('/setup/calendaring')) {
    return CalendarSeatSetupOrder
  }
  if (pathname.includes('touchless') || pathname.includes('start')) {
      return TouchlessSetupOrder
    }
  return MeetingsSetupOrder
}

export const getPercentage = (state) => {
  const pathname = getPathname(state)
  const order = getOrder(pathname, state)
  const section = pathname.split('/').slice(1).join('/')

  // only want to show a complete progress bar to the calendaring flow
  if (pathname.startsWith('/setup/calendaring')) {
    return Math.round((order.indexOf(section) / (order.length - 1)) * 100)
  } else {
    return Math.round((order.indexOf(section) / order.length) * 100)
}
}



// WEBPACK FOOTER //
// ./src/modules/routing/selectors.js